<template>
  <div v-loading="listWrapLoading" class="orderlist">
    <el-tabs is-dot :value="10" class="orderlist-tabs orderlist-tabs-status" v-model="activeName" @tab-click="topTabsChange">
      <el-tab-pane label="全部" name="0">
      </el-tab-pane>
      <el-tab-pane label="已上架" name="1">
      </el-tab-pane>
      <el-tab-pane label="下架" name="2">
        <span slot="label">
          下架
        </span>
      </el-tab-pane>
    </el-tabs>

    <goodslist v-if="listShow" :key="updataChild" :searchParams="searchParams" :dataList="dataList" :pagination="pagination" @updataCount="updataCount"></goodslist>
  </div>
</template>
<script>
import goodslist from "@/components/list/goodslist.vue";
export default {
  data () {
    return {
      listWrapLoading: true,
      listShow: true,
      dataList: { data: [], topCon: true, tableTopCon: true, pagi: true },
      activeName: "0",
      updataChild: "",
      normal_num: 0,
      seckill_num: 0,
      collage_num: 0,
      help_num: 0,
      sale_num: 0,
      not_sale: 0,
      status: "",
      //搜索参数
      searchParams: {
        sale: "0",
        type: "normal"  // 默认设置为普通类型
      },
      pagination: {}
    };
  },
  created () {
    this.sale = this.status1;
    this.activeName = this.status1;
    // 默认设置为普通类型商品
    this.getGoodsData({
      sale: this.status1,
      type: 'normal',
      order: '6',
      sorted: 'desc'
    });
    this.getTypeNum();
  },
  watch: {
    updataList () {
      if (this.updataList) {
        // 获取到返回列表，更新列表
        this.getGoodsData({
          type: 'normal',  // 默认设置为普通类型
          order: '6',
          sorted: 'desc'
        });
        this.status = "normal";  // 设置为普通类型
        // 更新统计红点
        this.getTypeNum();

        this.$store.dispatch("setUpdataList", false);
      }

    }

  },
  computed: {
    //列表状态
    status1: {
      get: function () {
        return this.getSliderStatus(this.$store.state._status);
      },
      set: function () { }
    },
    updataList: {
      get: function () {
        return this.$store.state.updataList;
      },
      set: function () { }
    },
    showNormal () {
      return this.normal_num <= 0 ? true : false;
    },
    showSeckill () {
      return this.seckill_num <= 0 ? true : false;
    },
    showCollage () {
      return this.collage_num <= 0 ? true : false;
    },
    showHelp () {
      return this.help_num <= 0 ? true : false;
    },
    showSale () {
      return this.sale_num <= 0 ? true : false;
    },
    showNotSale () {
      return this.not_sale <= 0 ? true : false;
    }
  },
  methods: {
    // 商品状态切换
    topTabsChange (row) {
      let sale = row.name;
      this.status = "normal";  // 设置为普通类型
      this.searchParams.sale = row.name;
      this.searchParams.type = "normal";  // 默认设置为普通类型
      this.getGoodsData(this.searchParams);
    },
    getGoodsData (params) {
      this.$store.dispatch("setTableLoading", true);
      this.$axios
        .get("/api/v1/products", { params: params })
        .then(res => {
          if (res.data.status == "200") {
            let resData = res.data;
            this.dataList.data = resData.data;
            //获取页码数据
            this.pagination = resData.meta.pagination;

            this.listShow = true;
            //更新子组件
            this.updataChild = new Date().getTime();
            this.listWrapLoading = false;
            this.$store.dispatch("setTableLoading", false);
          } else {
            this.$popup(res.data.msg, "error");
          }
        })
        .catch(error => { });
    },
    // 红点统计
    getTypeNum () {
      this.$store.dispatch("setTableLoading", true);
      this.$axios
        .get("/api/v1/count")
        .then(res => {
          if (res.data.status == "200") {
            let ret = res.data;
            let data = ret.data;
            this.normal_num = data.normal;
            this.seckill_num = data.seckill;
            this.help_num = data.help;
            this.collage_num = data.collage;
            this.sale_num = data.sale;
            this.not_sale = data.not_sale;
            this.$store.dispatch("setTableLoading", false);
          } else {
            this.$popup(res.data.msg, "error");
          }
        })
        .catch(error => { });
    },
    // 子组件触发父列表的红点统计更新
    updataCount () {
      this.getTypeNum();
    },


    getSliderStatus (text) {
      switch (text) {
        case "已下架商品":
          return "2";
          break;
        default:
          break;
      }
    }
  },
  components: {
    goodslist
  }
};
</script>

<style lang="less">
.orderlist-tabs {
  &.orderlist-tabs-status .el-tabs__item.is-active:focus {
    color: #081234 !important;
  }
  .el-tabs__header {
    height: 52px;
    margin-bottom: 10px;
    background-color: #ffffff;
    .el-tabs__nav-wrap,
    .el-tabs__nav-scroll,
    .el-tabs__nav,
    .el-tabs__item,
    .el-badge {
      height: 100%;
    }
    .el-tabs__nav-wrap::after {
      height: 0;
    }
    .el-tabs__active-bar {
      height: 4px;
      background-color: #2e71fe;
    }
    .el-tabs__item.is-active {
      color: #081234;
    }
    .el-tabs__item {
      width: 86px;
      line-height: 52px;
    }
    .el-badge__content.is-fixed {
      right: 4px;
      top: 12px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/goods-list.vue